/**
 * `/ban-do` — "Xem toàn màn hình" của ô Bản đồ tủ (GD-17 B3). CÙNG thành phần `BanDoTu`, chỉ cao
 * hơn. ⛔ Không có mục trong thanh điều hướng (phiếu cấm thêm mục) — chỉ vào từ nút trên bản đồ.
 */
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAlarms, useTree } from '../lib/queries';
import { BanDoTu } from '../components/BanDoTu';
import { ErrorBox, Spinner } from '../components/ui';

export default function BanDoPage() {
  const tree = useTree();
  const alarms = useAlarms();
  useEffect(() => { document.title = 'Bản đồ tủ — SDKD Chiếu sáng'; }, []);
  return (
    <div className="space-y-4">
      <div className="flex flex-wrap items-center gap-3">
        <h1 className="chu-tieude m-0 text-[20px] font-semibold leading-tight text-chu-1">Bản đồ tủ</h1>
        <Link to="/" className="ml-auto text-sm text-nhan hover:underline">← Về Tổng quan</Link>
      </div>
      {tree.isLoading && <Spinner label="Đang tải danh sách tủ…" />}
      {tree.isError && <ErrorBox error={tree.error} onRetry={() => void tree.refetch()} />}
      <BanDoTu cay={tree.data} canhBao={alarms.data} caoLop="h-[calc(100vh-15rem)] min-h-[320px]" toanManHinh />
    </div>
  );
}
